// import React from 'react';
// import premiumCerti from "../asset/premiumCeritfied.jpg"

// const About = () => {
//   return (
//     <div className="bg-gray-50 p-8">
//       <header className="text-center mb-12">
//         <h1 className="text-4xl font-bold text-blue-700 mb-4">Welcome to Home Electric</h1>
//         <p className="text-lg text-gray-700">
//           Your trusted partner for high-quality electrical appliances that blend quality with affordability.
//         </p>
//       </header>

//       <section className="max-w-4xl mx-auto mb-12">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-4">About Us</h2>
//         <p className="text-base text-gray-700 mb-4">
//           At Home Electric, we offer an extensive range of switches, socket boards, wires, and accessories
//           meticulously designed to meet stringent performance and durability standards. Our commitment to
//           excellence ensures that each product undergoes rigorous testing, guaranteeing reliability and safety
//           for all your home or business projects. What sets us apart is our dedication to providing value
//           without compromise, offering competitive pricing without sacrificing product integrity.
//         </p>
//         <p className="text-base text-gray-700 mb-4">
//           Moreover, we're deeply committed to sustainability, actively promoting energy-efficient solutions and
//           eco-friendly practices to minimize our environmental impact. Backed by our knowledgeable team of
//           professionals, we're here to assist you every step of the way, from product selection to installation
//           guidance and beyond. Join us at Home Electric and experience the difference that quality, affordability,
//           and exceptional customer service can make for your electrical needs.
//         </p>
//       </section>

//       <section className="max-w-4xl mx-auto mb-12">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-4">Quality</h2>
//         <p className="text-base text-gray-700 mb-4">
//           At Home Electric, quality is our cornerstone. We meticulously select and test each of our products
//           to ensure they meet the highest standards of performance, durability, and safety. Our dedication to
//           quality extends beyond just the products themselves; it's ingrained in every aspect of our operations,
//           from our customer service to our commitment to sustainability. With Home Electric, you can trust that
//           you're getting not just a product, but a guarantee of excellence that will meet and exceed your expectations.
//         </p>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
//           <img src={premiumCerti} alt="Premium" className="w-full rounded-lg shadow-lg"/>
//         </div>
//       </section>

//       <section className="max-w-4xl mx-auto mb-12">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-4">Affordability</h2>
//         <p className="text-base text-gray-700 mb-4">
//           At Home Electric, affordability is paramount. We understand the importance of staying within budget
//           without compromising on quality. That's why we work tirelessly to offer competitive pricing on all our
//           products, ensuring that our customers can access high-quality electrical appliances without breaking the bank.
//           Our streamlined processes and strong relationships with manufacturers enable us to pass on cost savings to you,
//           making top-notch electrical solutions accessible to everyone. With Home Electric, affordability isn't just a promise—it's a
//           commitment we uphold every day.
//         </p>
//       </section>

//       <section className="max-w-4xl mx-auto mb-12">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-4">Durability</h2>
//         <p className="text-base text-gray-700">
//           Durability is at the core of what we do at Home Electric. We recognize the importance of products that
//           can withstand the test of time, whether in residential, commercial, or industrial settings. That's why
//           we meticulously select materials and rigorously test each item in our inventory to ensure they meet our
//           stringent durability standards. From switches to socket boards, wires, and accessories, our products are
//           built to last, providing long-term reliability and peace of mind for our customers. With Home Electric,
//           you can trust that your investment will stand strong for years to come.
//         </p>
//       </section>
//     </div>
//   );
// };

// export default About;



// ── ABOUT ─────────────────────────────────────────────────────────────────────
import React, { useState } from 'react';
import premiumCerti from '../asset/premiumCeritfied.jpg';
import { BsLightningChargeFill, BsShieldFillCheck } from 'react-icons/bs';
import { MdEco, MdVerified } from 'react-icons/md';
import { FaIndustry } from 'react-icons/fa';

export function About() {
  const values = [
    {
      icon: <BsShieldFillCheck />,
      color: 'var(--indigo)',
      bg: 'var(--indigo-dim)',
      title: 'Quality',
      body: 'Every product passes rigorous testing to meet BIS performance, durability, and safety standards. Quality is non-negotiable.',
    },
    {
      icon: <BsLightningChargeFill />,
      color: 'var(--amber)',
      bg: 'rgba(251,191,36,0.1)',
      title: 'Affordability',
      body: 'Competitive pricing without compromise. Strong supplier relationships let us pass savings directly to our customers.',
    },
    {
      icon: <FaIndustry />,
      color: 'var(--cyan)',
      bg: 'var(--cyan-dim)',
      title: 'Durability',
      body: 'Built for residential, commercial, and industrial environments. Products engineered to last years, not months.',
    },
    {
      icon: <MdEco />,
      color: 'var(--green)',
      bg: 'rgba(52,211,153,0.1)',
      title: 'Sustainability',
      body: 'Actively promoting energy-efficient solutions and eco-friendly practices to minimise our environmental footprint.',
    },
  ];

  return (
    <div
      className="min-h-screen py-16 px-4 md:px-6 relative"
      style={{ background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)' }}
    >
      {/* Blob */}
      <div className="pointer-events-none absolute"
        style={{
          top: '10%', left: '50%', transform: 'translateX(-50%)',
          width: 700, height: 400,
          background: 'radial-gradient(ellipse, rgba(99,102,241,0.08) 0%, transparent 70%)',
          filter: 'blur(80px)'
        }} />

      <div className="max-w-5xl mx-auto">

        {/* Hero text */}
        <div className="text-center mb-14 animate-fade-up">
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-6"
            style={{ background: 'var(--indigo-dim)', border: '1px solid rgba(99,102,241,0.3)' }}
          >
            <BsLightningChargeFill className="text-2xl" style={{ color: 'var(--cyan)' }} />
          </div>
          <p className="section-eyebrow justify-center mb-3">Our Story</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4"
            style={{ color: 'var(--text-primary)' }}>
            ABOUT <span className="text-gradient">HOME ELECTRIC</span>
          </h1>
          <p className="max-w-2xl mx-auto text-base leading-relaxed"
            style={{ color: 'var(--text-secondary)' }}>
            Your trusted partner for high-quality electrical appliances that blend quality with affordability.
          </p>
        </div>

        {/* Story card */}
        <div
          className="glass rounded-2xl p-8 mb-8 animate-fade-up delay-100"
          style={{ border: '1px solid var(--glass-border)' }}
        >
          <h2 className="font-display text-xl font-bold mb-4 flex items-center gap-2"
            style={{ color: 'var(--text-primary)' }}>
            <MdVerified style={{ color: 'var(--indigo-light)' }} />
            WHO WE ARE
          </h2>
          <div className="divider mb-5" />
          <p className="text-sm leading-relaxed mb-3" style={{ color: 'var(--text-secondary)' }}>
            At Home Electric, we offer an extensive range of switches, socket boards, wires, and accessories
            meticulously designed to meet stringent performance and durability standards. Our commitment to
            excellence ensures each product undergoes rigorous testing, guaranteeing reliability and safety.
          </p>
          <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text-secondary)' }}>
            Starting just two years ago, we've rapidly expanded from basic holders to a full range including
            modular metal boxes, MCBs, distribution boards, and more. Our vision: to be one of India's
            leading electrical manufacturers — quality at an affordable price, always.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
            <div>
              <p className="font-mono text-xs mb-1" style={{ color: 'var(--text-muted)' }}>FOUNDER</p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Akshat Jain</p>
            </div>
            <div>
              <p className="font-mono text-xs mb-1" style={{ color: 'var(--text-muted)' }}>CONTACT</p>
              <p className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>+91 8963008378</p>
              <a href="mailto:fiercfly@gmail.com" className="text-sm text-gradient hover:opacity-80 transition-opacity">
                fiercfly@gmail.com
              </a>
            </div>
            <div className="sm:col-span-2">
              <p className="font-mono text-xs mb-1" style={{ color: 'var(--text-muted)' }}>HEADQUARTERS</p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Udaipur, Rajasthan, India</p>
            </div>
          </div>
        </div>

        {/* Values grid */}
        <div className="grid md:grid-cols-2 gap-5 mb-8">
          {values.map(({ icon, color, bg, title, body }, i) => (
            <div
              key={title}
              className="glass-card rounded-2xl p-6 flex items-start gap-4 animate-fade-up"
              style={{ animationDelay: `${150 + i * 80}ms` }}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 text-xl"
                style={{ background: bg, color }}
              >
                {icon}
              </div>
              <div>
                <h3 className="font-display text-base font-bold mb-1.5"
                  style={{ color: 'var(--text-primary)' }}>
                  {title.toUpperCase()}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                  {body}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Certification */}
        <div
          className="glass rounded-2xl overflow-hidden md:flex gap-0 animate-fade-up delay-400"
          style={{ border: '1px solid var(--glass-border)' }}
        >
          <div className="md:w-1/2 p-8 flex flex-col justify-center">
            <p className="section-eyebrow mb-3">Recognised Quality</p>
            <h2 className="font-display text-2xl font-bold mb-4"
              style={{ color: 'var(--text-primary)' }}>
              PREMIUM <span className="text-gradient">CERTIFIED</span>
            </h2>
            <p className="text-sm leading-relaxed mb-5" style={{ color: 'var(--text-secondary)' }}>
              All products carry the ISI mark and are tested to BIS standards, giving you
              total peace of mind in every installation.
            </p>
            <div className="flex flex-wrap gap-2">
              {['ISI Mark', 'BIS Certified', 'RoHS', 'Made in India'].map(tag => (
                <span key={tag} className="badge-cyan">{tag}</span>
              ))}
            </div>
          </div>
          <div className="md:w-1/2 overflow-hidden" style={{ maxHeight: 300 }}>
            <img
              src={premiumCerti}
              alt="Premium Certification"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;